export type NavLink = { to: string; label: string };

export type NavDropdown = {
  label: string;
  children: NavLink[];
};

export type NavItem = NavLink | NavDropdown;

export function isDropdown(item: NavItem): item is NavDropdown {
  return "children" in item;
}

/**
 * Feature flag check for optional marketing pages.
 * Only pages that may be toggled off need flags - standard pages
 * (home, about, contact, legal, brand, products) are always visible.
 */
const FLAG_MAP: Record<string, string> = {
  // /solutions had a flag while it was a ComingSoon stub. It is a real page as
  // of 2026-08-06, so it is a standard page now and the flag is gone - leaving
  // it would have meant a finished, indexed, sitemapped page that is absent from
  // the navigation until a repository variable is changed by hand.
  "/industries": "VITE_SHOW_INDUSTRIES_PAGE",
  "/resources": "VITE_SHOW_RESOURCES_PAGE",
};

function isPageEnabled(to: string): boolean {
  const flag = FLAG_MAP[to];
  if (!flag) return true; // no flag = always visible
  return import.meta.env[flag] === "true";
}

function filterLinks(links: NavLink[]): NavLink[] {
  return links.filter((link) => isPageEnabled(link.to));
}

export const PRODUCTS_DROPDOWN: NavDropdown = {
  label: "Products",
  children: [
    { to: "/products/knowledge-base", label: "Knowledge Base" },
    { to: "/products/myapp", label: "MyApp" },
    { to: "/connectors/product", label: "Connectors" },
  ],
};

export const NAV_PRIMARY: NavItem[] = [
  { to: "/", label: "Home" },
  PRODUCTS_DROPDOWN,
  { to: "/pricing", label: "Pricing" },
  ...filterLinks([
    { to: "/solutions", label: "Solutions" },
    { to: "/industries", label: "Industries" },
    { to: "/resources", label: "Resources" },
  ]),
];

export const NAV_PRIMARY_FLAT: NavLink[] = filterLinks([
  { to: "/solutions", label: "Solutions" },
  { to: "/industries", label: "Industries" },
  { to: "/resources", label: "Resources" },
]);

export const NAV_SECONDARY: NavLink[] = [
  { to: "/about", label: "About" },
  { to: "/videos", label: "Videos" },
];

export const NAV_LINKS = [...NAV_PRIMARY_FLAT, ...NAV_SECONDARY];

export const SECONDARY_LINKS: NavLink[] = [
  { to: "/legal/paia", label: "PAIA" },
  { to: "/brand", label: "Brand" },
];
